import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {capitalize} from 'src/utils/capitalize';

import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const Deprecated = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    return (
        <Group>
            <Group>
                <strong>Deprecated:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={HighlightFields.deprecated}/>
            </Group>
            <HighlighterWrapper
                actualValue={!eventCodeInfo ? '' : capitalize((!!eventCodeInfo?.deprecated).toString())}
                changeRequestValue={capitalize(changeRequest.event.deprecated.toString())}
                highlight={!!highlightsInfo?.[HighlightFields.deprecated]}>
                <Item>
                    {capitalize(changeRequest.event.deprecated.toString())}
                </Item>
            </HighlighterWrapper>
        </Group>
    );
};
